<template>
  <LegalPage title="Delivery Policy" last-updated="August 30, 2025">
    <p>
      This Delivery Policy explains how Nilkhet Books processes and delivers your
      orders across Bangladesh. Because many of our books are printed on order,
      please review the timelines below when planning your purchase.
    </p>

    <h2>1. Order Processing</h2>
    <p>
      Once your order is confirmed, we begin processing it right away. As our
      books are printed on order, printing and preparation typically take
      <strong>2–4 business days</strong> before your order is handed over to our
      delivery partner.
    </p>

    <h2>2. Delivery Timelines</h2>
    <ul>
      <li>
        <strong>Inside Dhaka:</strong> Approximately 2–3 business days after
        your order is prepared.
      </li>
      <li>
        <strong>Outside Dhaka:</strong> Approximately 3–5 business days after
        your order is prepared.
      </li>
    </ul>
    <p>
      Delivery times are estimates and may vary due to location, courier
      schedules, public holidays, weather, or other circumstances beyond our
      control.
    </p>

    <h2>3. Delivery Charges</h2>
    <p>
      Delivery charges are calculated based on your delivery location and are
      shown clearly at checkout before you confirm your order. Charges may differ
      for locations inside and outside Dhaka.
    </p>

    <h2>4. Delivery Coverage</h2>
    <p>
      We deliver nationwide across Bangladesh through our courier partners. Some
      remote areas may experience longer delivery times or limited coverage. If
      we are unable to deliver to your location, we will contact you to arrange an
      alternative.
    </p>

    <h2>5. Order Tracking</h2>
    <p>
      You can check the status of your order at any time from the
      <router-link to="/orders">My Orders</router-link> section of your account.
      We will also keep you updated on your order's progress.
    </p>

    <h2>6. Receiving Your Order</h2>
    <ul>
      <li>
        Please ensure someone is available at the delivery address to receive the
        order.
      </li>
      <li>
        We recommend inspecting your package upon delivery. If you notice any
        damage or defect, please refer to our
        <router-link to="/return-refund-policy">Return &amp; Refund Policy</router-link>.
      </li>
      <li>
        If a delivery attempt is unsuccessful, our courier partner will typically
        make another attempt or contact you to reschedule.
      </li>
    </ul>

    <h2>7. Delays</h2>
    <p>
      While we make every effort to deliver on time, occasional delays may occur.
      If your order is significantly delayed, please contact us and we will help
      resolve the issue.
    </p>

    <h2>8. Contact Us</h2>
    <div class="highlight-box">
      <p>
        <strong>Nilkhet Books</strong><br />
        Shop 146, 1st Floor, Gausul Azam Super Market, Nilkhet, Dhaka 1205<br />
        Phone: <a href="tel:+8801711086468">+880 1711 086 468</a><br />
        Email:
        <a href="mailto:nilkhetdotcom@gmail.com">nilkhetdotcom@gmail.com</a>
      </p>
    </div>
  </LegalPage>
</template>

<script>
import LegalPage from "@/components/LegalPage.vue";

export default {
  name: "DeliveryPolicy",
  components: { LegalPage },
};
</script>
